import React, { FC } from 'react'
import { capitalizeString } from 'lib/helpers'
import SeoContentConnector, { ConnectorProps as SeoContentProps } from '../../connectors/SeoContent'
import styles from './SEOContent.module.scss'

const RelatedSearches: FC<SeoContentProps> = ({ metadata }) => {
  const { sections, relatedSearchesHeader, relatedSearchesCopy } = metadata || {}
  const validSection = sections.includes('related_searches')

  if (!validSection || !relatedSearchesHeader || !relatedSearchesCopy) {
    return null
  }

  // Capatilize Ex: RELATED SEARCHES || related searches => Related Searches
  const title = capitalizeString(relatedSearchesHeader)
  // Remove commas, Ex: <a>Something</a>, <a>Else</a>, ... => <a>Something</a> <a>Else</a>
  const description = relatedSearchesCopy.replace(/(\s|,)+/g, ' ')

  return (
    <div className={styles.relatedSearchesContainer}>
      <h4>{title}</h4>
      <p dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  )
}

export default SeoContentConnector(RelatedSearches)
